// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"5bf31f57","977":"cdc8b1f9"}[chunkId] + ".chunk.js";
};